import domReady from '@wordpress/dom-ready';
import { createRoot, render, useState } from '@wordpress/element';

const Accordion = ( { attributes } ) => {
	const { faqs } = attributes;
	const [ active, setActive ] = useState( 1 );

	return (
		<div className="wedocs-gblocks-accordions">
			{ faqs.map( ( faq ) => (
				// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
				<div
					className={ `wedocs-gblocks-accordion ${
						faq.id === active ? 'wedocs-gblocks-accordion-active' : ''
					}` }
					key={ faq.id }
					onClick={ () => setActive( faq.id ) }
				>
					<div className="wedocs-gblocks-accordion-title">
						{ faq.question }
					</div>
					<div className="wedocs-gblocks-accordion-description">
						<p
							dangerouslySetInnerHTML={ {
								__html: faq.answer,
							} }
						></p>
					</div>
					{ faq.id === active ? (
						<svg
							width="16"
							height="2"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M0 1.363V0h16v1.363H0Z" fill="#F1634C" />
						</svg>
					) : (
						<svg
							width="16"
							height="16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M7.319 16V8.681H0V7.32h7.319V0H8.68v7.319H16V8.68H8.681V16H7.32Z"
								fill="#BDC3C7"
							/>
						</svg>
					) }
				</div>
			) ) }
		</div>
	);
};

domReady( () => {
	const mountElement = document.querySelectorAll(
		'.wp-block-wedocs-gblocks-faq'
	);
	const mountElementArr = Array.from( mountElement );

	mountElementArr.forEach( ( item ) => {
		if ( createRoot ) {
			createRoot( item ).render(
				<Accordion
					attributes={ JSON.parse(
						item.getAttribute( 'data-block-attributes' )
					) }
				/>
			);
		} else {
			render(
				<Accordion
					attributes={ JSON.parse(
						item.getAttribute( 'data-block-attributes' )
					) }
				/>,
				item
			);
		}
	} );
} );
